module.exports = __webpack_public_path__ + "static/media/Logo_7.7750614e.png";